export const RELEASE_NOTES_STORAGE_KEY = 'release-notes-storage'
